var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.525,
    height: 31.525,
    viewBox: "0 0 31.525 31.525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.157,
    y1: 0.095,
    x2: 0.891,
    y2: 0.961,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cf6301"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ffd31d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.348,
    stopColor: "#f5ca39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.394,
    stopColor: "#ffe489"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.422,
    stopColor: "#fff68a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.482,
    stopColor: "#ffdf49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.503,
    stopColor: "#ffd731"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.649,
    stopColor: "#d97907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#ffde00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.804,
    stopColor: "#fdd900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.846,
    stopColor: "#f7ca01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#eeb103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.941,
    stopColor: "#e18f05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951,
    stopColor: "#de8606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea9600"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Plus_sign-07",
    "data-name": "Plus sign-07",
    d: "M15.227,12.05A8.407,8.407,0,0,0,6.82,20.457V35.168a8.407,8.407,0,0,0,8.407,8.407H29.938a8.407,8.407,0,0,0,8.407-8.407V20.457a8.407,8.407,0,0,0-8.407-8.407Zm.526,15.762A1.051,1.051,0,0,1,16.8,26.761h4.729V22.032a1.051,1.051,0,0,1,2.1,0v4.729h4.729a1.051,1.051,0,1,1,0,2.1H23.634v4.729a1.051,1.051,0,1,1-2.1,0V28.863H16.8A1.052,1.052,0,0,1,15.752,27.812Z",
    transform: "translate(-6.82 -12.05)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/see-more.79a45d5db4d39e0efcdbc3a9625238e3.svg";
export { ForwardRef as ReactComponent };